import { TableColumn } from "../../models/tables/TableColumn";
import { COLUMN_TYPES } from "../COLUMN_TYPES";

export const SALARIES_COLUMNS: TableColumn[] = [
    {
        name: "fullName", 
        displayName: "Name", 
        dataType: COLUMN_TYPES.string, 
        isEditable: true, 
        isEditableOnNew: true, 
        styles: {width: '80%'},
        reference: '',
        selectOptions: null
    },
    {
        name: "dailyTripHistoryTotal", 
        displayName: "Total", 
        dataType: COLUMN_TYPES.currency, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {width: '20%'},
        reference: '',
        selectOptions: null
    }
]


// WEBPACK FOOTER //
// ./src/app/contants/columns/columns.salaries.ts